const DrawLocation_CTS = ({ orderInfo }) => {
  if (!orderInfo?.reqinfo) return <p>No requisition info available.</p>;

  return (
    <div>
  {Object.entries(orderInfo.reqinfo).map(([reqNum, req]) => {
    const displayItems = req.displaycodes
      ?.split('~')
      .map((entry) => entry.trim())
      .filter(Boolean) || [];

    const reqTests = req.ReqTestsID || [];
    const destlab = req.lab;

    // Find the first scheduling URL (if any exist)
    const firstSchedulingUrl = reqTests.find(
      (test) => test?.AdditionalInfo?.['i3Screen.scheduling_url']
    )?.AdditionalInfo?.['i3Screen.scheduling_url'];

    return (
      <div key={reqNum} style={{ marginBottom: '2rem', marginTop: '4rem' }}>
        {/* LabCorp link shown once if LCA */}
        {destlab === 'LCA' && !firstSchedulingUrl && (
          <a
            href="https://www.labcorp.com/labs-and-appointments/results"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here to schedule with LabCorp
          </a>
        )}
		{/* Show scheduling link once per requisition */}
        {firstSchedulingUrl ? (
          <a
            href={firstSchedulingUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Click here to schedule your test collection or view Donor Pass of an already scheduled test
          </a>
        ) : destlab !== 'LCA' ? (
          <p>No scheduling link available.</p>
        ) : null}
        {/* Render tests */}
        {displayItems.map((testStr, index) => {
          const name = testStr.split(' -').slice(1).join(' -').trim(); // test name
          return (
            <div key={index} style={{ paddingLeft: '1rem' }}>
              <p>{name}</p>
            </div>
          );
        })}

                <p><strong>&nbsp;&nbsp;&nbsp;&nbsp;Requisition #{req.disReqNum}</strong></p>
      </div>
    );
  })}
</div>

  );
};

export default DrawLocation_CTS;
